import React from "react";
import SEOHead from "../components/SEOHead";
import blogPosts from "../data/blogPosts";
import "./blog.css";

const TICKER_ITEMS = [
  { label: "BOOM 1000", detail: "SPIKE FREQ ~1 / 1000 TICKS", dot: "up" },
  { label: "CRASH 500", detail: "SPIKE FREQ ~1 / 500 TICKS", dot: "down" },
  { label: "RISK", detail: "SIZE FOR THE TAIL, NOT THE AVERAGE", dot: "signal" },
  { label: "BOOM 300", detail: "HIGH FREQUENCY VARIANT", dot: "up" },
  { label: "CRASH 1000", detail: "SPIKE FREQ ~1 / 1000 TICKS", dot: "down" },
  { label: "STRATEGY", detail: "DEFINE THE SETUP, NOT THE PREDICTION", dot: "signal" },
];

export function navClick(onNavigate, path) {
  return (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onNavigate(path);
  };
}

export function categorySlug(category) {
  return category.toLowerCase().replace(/\s+/g, "-");
}

export function formatMonoDate(dateString) {
  return dateString.split("-").join(".");
}

function SignalTicker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="blog-ticker" aria-hidden="true">
      <div className="blog-ticker-track">
        {items.map((item, index) => (
          <span className="blog-ticker-item" key={`${item.label}-${index}`}>
            <span className={`blog-ticker-dot blog-ticker-dot-${item.dot}`} />
            <strong>{item.label}</strong> {item.detail}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Blog({ onNavigate }) {
  const sortedPosts = [...blogPosts].sort(
    (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
  );

  return (
    <div className="blog-shell">
      <div className="blog-container">
        <header className="blog-topnav">
          <a
            href="/"
            className="blog-brand"
            onClick={navClick(onNavigate, "/")}
          >
            Spike Hunter Online <span>Trading Intelligence</span>
          </a>
          <a href="/" className="blog-back-link" onClick={navClick(onNavigate, "/")}>
            ← Home
          </a>
        </header>

        <SignalTicker />

        <section className="blog-header">
          <div className="blog-eyebrow">Trading Notes</div>
          <h1>Boom &amp; Crash index trading, explained without the hype.</h1>
          <p>
            Long-form breakdowns on how synthetic indices actually behave, how
            to structure a strategy around spike risk, and how to size
            positions so one bad tick doesn't end the account.
          </p>
        </section>

        {sortedPosts.length === 0 ? (
          <div className="blog-empty-state">No posts published yet.</div>
        ) : (
          <div className="blog-grid">
            {sortedPosts.map((post, index) => (
              <a
                key={post.slug}
                href={`/blog/${post.slug}`}
                className="blog-card"
                onClick={navClick(onNavigate, `/blog/${post.slug}`)}
              >
                <span className="blog-card-index">
                  {String(sortedPosts.length - index).padStart(2, "0")}
                </span>
                <div className="blog-card-meta">
                  <span className={`blog-chip blog-chip-${categorySlug(post.category)}`}>
                    {post.category}
                  </span>
                  <span>{post.readTime} MIN READ</span>
                </div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <div className="blog-card-footer">
                  <time dateTime={post.publishDate}>{formatMonoDate(post.publishDate)}</time>
                  <span aria-hidden="true">→</span>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>

      <SEOHead
        title="Trading Notes: Boom & Crash Index Strategy | Spike Hunter Online"
        description="Long-form guides on Boom and Crash synthetic indices — how spikes work, strategy frameworks, and risk management for traders who use them."
        path="/blog"
        type="website"
      />
    </div>
  );
}
